import React from 'react';
import './logo.styles.scss';

type Props = Record<string, unknown>;

type State = Record<string, unknown>;

class Logo extends React.Component<Props, State> {
  componentDidMount(): void {
    const paths = document.getElementsByTagName('path');

    for (let i = 0; i < paths.length; i++) {
      const path = paths[i];
      const length = path.getTotalLength();
      path.style.strokeDasharray = length + ' ' + length;
      path.style.strokeDashoffset = length.toString();
    }

    setTimeout(async () => {
      for (let i = 0; i < paths.length; i++) {
        const path = paths[i];
        path.setAttribute('style', 'fill-opacity: 66%');
        await this.sleep(100);
      }
    }, 750);
  }

  async sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  render(): React.ReactNode {
    return (
      <div className="LogoComp" title="Programmer's Toolbox by Chinh Do">
        <svg id="logo" version="1.1" viewBox="-5 -5 297 275">
          <g className="bottom">
            <path
              id="logo-bottom"
              fill="red"
              d="M248.6,102.82c-25.34-43.23-51.1-58.49-105.38-57.54c-57.4-0.04-111.07,31.6-121.2,100.47
	c-6.47,65.8,37.27,111.21,104.35,117.76c76.92,5.37,151.45-26.24,136.84-110.01c-1.38-0.87-78.41-5.37-78.41-5.37
	c1.49,24.37-14.83,42.16-32.72,42.16c-27.95,0.99-43.83-13.32-42.71-51.78c-2.46-47.4,18.78-62.39,31.53-62.39
	c8.94,0,32.42-2.91,38.49,29.72L248.6,102.82z"
            />
            <path
              fill="red"
              d="M178.46,175.86c-8.57,10.47-19.48,14.78-32.2,14.31c-14.33-0.74-24.83-6.93-31.98-17.89
	c-5.56-14.07-7.25-40.56-9.39-68.87c1.53,26.85,16.17,39.86,44.5,40.25c25.75-0.91,38.79-11.05,40.7-29.29
	C185.37,151.77,181.29,176.38,178.46,175.86z"
            />
            <path
              id="logo-mid-top"
              fill="red"
              d="M248.23,103.64c-20.47-47.91-66.48-67.82-143.33-53.89c-64.5,21.18-86.38,67.08-82.51,127.9
	C2.09,156.98-4.46,129.4,3.61,94.47C27.39,18.98,87.56-6.17,171.76,1.9c45.63,4.13,74.04,24.07,91.75,53.81L248.23,103.64z"
            />
          </g>

          <g className="mid">
            <path
              fill="red"
              d="M109.59,123.99c-3.38-9.52-5.49-21.15-5.29-36.67c-1.31-28.3,7.54-53.45,35.7-58.58
c18.56-2.68,42.07,8.54,43.9,29.37l-4.52,47.76c-3.87-20.49-15.31-30.83-35.13-29.95C122.06,76.9,112.14,95.24,109.59,123.99z"
            />
            <path
              fill="red"
              d="M263.88,153.28l20.35-48.07c3.73,13.05,3.35,32.2-0.67,47.18c-9.74,23.13-18.14,43.61-24.82,55.45
	C264.62,191.06,267.5,170.52,263.88,153.28"
            />
            <path
              fill="red"
              d="M263.51,55.71l-15.28,47.93l-68.84,2.22l4.52-47.76C183.88,57.17,263.48,54.78,263.51,55.71"
            />
            <path
              fill="red"
              d="M284.68,104.31l-21.02,48.07c-0.04,1.01-77.85-2.12-77.81-3.13l5.59-46.96L284.68,104.31"
            />
          </g>

          <g className="top">
            <path
              fill="yellow"
              d="M241.97,231.09c-30.32,25.28-64.74,35.6-102.86,32.42c-31.79,0.29-60.77-9.15-86.53-29.74
	c-8.2-7.45-15.96-18.26-23.39-31.48c-2.07-3.67-4.11-7.54-6.13-11.56c-4.8-9.56-9.48-20.05-14.08-31.2
	c27.12,45.74,74.75,64.84,136.4,65.74c68.13-2.72,112.11-20.01,132.37-59.7C266.07,195.27,256.16,218.27,241.97,231.09z"
            />
            <path
              fill="blue  "
              d="M263.51,55.71C237.3,13.03,198.4,2.28,145.05,0.49C69.01-2.07,10.83,37.74,1.45,111.06
	c-8.05,68.16,59.18,107.74,125.52,113.1c81.69,7.75,176.05-29.29,157.27-118.96c-1.38-0.87-92.57-4.1-92.57-4.1
	c0.61,25.92-10.29,48.15-58.58,41c-29.59-8.98-27.92-35.91-28.77-54.78c-2.45-55.9,37.27-58.43,37.27-58.43s39.89-3.03,42.34,29.22
	L263.51,55.71z"
            />
          </g>
        </svg>
      </div>
    );
  }
}

export default Logo;
